export default __webpack_public_path__ + "static/media/ModalBg.ad096bca.svg";